'use client';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

/**
 * Minimal market/event view types. Intentionally a structural SUBSET of the
 * main-app `MarketVo`/`EventVo` (which carry 100+ fields) so the config engine
 * does not inherit main-app type churn. The actual widgets still render the full
 * main-app components via the embed iframe.
 */
export interface WidgetMarket {
    id: string;
    ticker_name: string;
    title: string;
    yes_sub_title?: string;
    last_price: number;
    status?: string;
    rulebook_variables?: { image_link?: string };
}

export interface WidgetEvent {
    ticker: string;
    title: string;
    series_ticker: string;
    markets: WidgetMarket[];
}

async function fetchWidgetEvent(eventTicker: string): Promise<WidgetEvent | null> {
    const res = await fetch(`/api/widgets/events/${encodeURIComponent(eventTicker)}`);
    if (!res.ok) return null;
    return (await res.json()) as WidgetEvent;
}

/** Resolve an event (and its markets) for market-select fields. */
export function useEvent(eventTicker: string): UseQueryResult<WidgetEvent | null> {
    return useQuery({
        queryKey: ['widget-event', eventTicker],
        queryFn: () => fetchWidgetEvent(eventTicker),
        enabled: Boolean(eventTicker),
        staleTime: 30_000,
    });
}
